import axios from 'axios';
import AppSettings from '../appsettings';

const BASE_URL = `${AppSettings.API_BASE_URL}/properties`;

const propertyService = {
  // ✅ Get all properties
  getAll: async () => {
    const response = await axios.get(`${BASE_URL}`);
    return response.data;
  },

  // ✅ Get all properties for a specific publisher
  getByPublisher: async (publisherId) => {
    const response = await axios.get(`${BASE_URL}/GetAllPublisherPropert/${publisherId}`);
    return response.data;
  },

  // ✅ Get single property by ID
  getById: async (id) => {
    const response = await axios.get(`${BASE_URL}/${id}`);
    return response.data;
  },

  // ✅ Create new property
  create: async (propertyData) => {
    const response = await axios.post(`${BASE_URL}`, propertyData);
    return response.data;
  },

  // ✅ Update property
  update: async (id, propertyData) => {
    const response = await axios.put(`${BASE_URL}/${id}`, propertyData);
    return response.status === 204;
  },

  // ✅ Delete property
  delete: async (id) => {
    const response = await axios.delete(`${BASE_URL}/${id}`);
    return response.status === 204;
  },

  getWebsitesByPublisher: async (publisherId) => {
    const response = await axios.get(`${BASE_URL}/GetAllPublisherPropertiesByType/${publisherId}/Website`);
    return response.data;
  },

  getAppsitesByPublisher: async (publisherId) => {
    const response = await axios.get(`${BASE_URL}/GetAllPublisherPropertiesByType/${publisherId}/App`);
    return response.data;
  },
};

export default propertyService;
